import { messageService } from '../../utils/messageService'

export const isTimeIntervalValid = (startTime, endTime) => {
    // If either time is not set, consider it invalid
    if (!startTime || !endTime) {
        return false;
    }
    
    // Calculate difference in seconds
    const diffInSeconds = Math.abs(endTime - startTime);
    const maxSeconds = 5 * 60; // 5 minutes
    
    // Check if start is before end AND interval is <= 5 minutes
    return startTime < endTime && diffInSeconds <= maxSeconds;
};


export const handleDownload = (periscope_stream_id, lowres_stream_id, start, end, timelapse_mode, target_time, use_low_res) => {
    const token = localStorage.getItem('token');
    // Create temporary link and click it
    var stream_id = periscope_stream_id
    const link = document.createElement('a');
    if (use_low_res){
        stream_id = lowres_stream_id
    }
    link.href = process.env.REACT_APP_DOWNLOAD_URL + `/ovms/proxyArchive?periscope_stream_id=${stream_id}&start=${start}&end=${end}&token=${token}&timelapse_tf=${timelapse_mode}&target_length_m=${target_time}`
    link.download = 'archive.mkv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    console.log('Download started!');
};